<template>
  <div class="image-upload" :class="{'full-width': isFullWidth}">
    <image-upload ref="imageUpload" :image="uploadImageUrl" :callback="setImage" proxyWidth="625" proxyHeight="500"></image-upload>
  </div>
</template>

<script>
import ImageUpload from '@/components/Inputs/ImageUpload'
import { v1 as uuidGenerator } from 'uuid'

export default {
  name: 'uploadImage',
  components: { ImageUpload },
  props: {
    fileName: {
      type: String,
      required: true
    },
    fileLocation: {
      type: String,
      required: true
    },
    isFullWidth: {
      type: Boolean,
      default: false
    }
  },
  data: function () {
    return {
      uploadImageUrl: ''
    }
  },
  methods: {
    upload: async function () {
      if (this.fileName === '' || this.uploadImageUrl === '') {
        // this.errorMessage = 'Please provide a file location, name and image url'
        return
      }
      const key = this.fileName.replace(/\s/g, '') + '-' + uuidGenerator()
      try {
        const url = await this.uploadImage(this.fileLocation, key)
        if (url) this.$emit('imageURL', url)
      } catch (error) {
        this.errorMessage = error
      }
    },
    setImage: function (value, type) {
      this.uploadImageUrl = value
      if (value === '') {
        return
      }
      if (type === 'image') {
        this.$emit('imageURL', value)
      } else {
        this.upload()
      }
    },
    uploadImage: function (bucketName, key) {
      if (this.$refs.imageUpload) {
        return this.$refs.imageUpload.upload(bucketName, key)
      }
    }
  }
}
</script>

<style lang="scss" scoped>

.image-upload {
  width: 200px;
  height: 200px;
  border: none;
  padding: 0;
}

.full-width {
  width: 100%;
}

</style>
